export default __webpack_public_path__ + "static/media/plane.da8ea829.png";